import type { ComponentProps } from "react"

export default function IndustryG(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M24.7733 12.9972L19.824 4.33057L17.5093 5.65323L21.7026 12.9866H10.2973L14.4906 5.65323L12.176 4.3359L7.22663 12.9972H2.66663V15.6639H4.26663L6.69996 26.6199C6.76573 26.9158 6.93033 27.1804 7.16665 27.3702C7.40296 27.5599 7.69688 27.6635 7.99996 27.6639H24C24.3035 27.6642 24.598 27.5608 24.8349 27.371C25.0718 27.1812 25.2368 26.9162 25.3026 26.6199L27.7333 15.6639H29.3333V12.9972H24.7733ZM12 23.6639H9.33329V16.9972H12V23.6639ZM17.3333 23.6639H14.6666V16.9972H17.3333V23.6639ZM22.6666 23.6639H20V16.9972H22.6666V23.6639Z"
        fill={fill}
      />
    </svg>
  )
}
